import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import Loader from '../Common/Loader';
import LibraryUpload from './LibraryUpload';
import LibraryFiles from './LibraryFiles';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import LocalizedStrings from './localization';

const styles = {
    selectedTab: {
        backgroundColor: 'rgb(192, 0, 0)',
    }
};

class LibraryFrame extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeItem: 0,
            fieldErrors: {},
            filterSession: false,
        };
    }

    handleTabChange = (evt, value) => {
        this.setState({ activeItem: value });
    }

    showCurrentSession = (sessionId, uploadedIds, filters) => {
        this.setState({ sessionId, uploadedIds, uploadedFilters: filters, activeItem: 1, });
    }

    currentSessionLoaded = () => {
        this.setState({ sessionId: undefined, uploadedIds: undefined, uploadedFilters: undefined });
    }

    render() {
        // if (this.props.currentUserIsAdmin === undefined || this.props.currentUserSub === undefined) {
        //     return (
        //         <Loader loading={true} size='100px' />
        //     );
        // } else {
        let libraryBody = null;
        let activeItem = this.state.activeItem;
        if (this.props.isPicker) {
            activeItem += 1;
        }
        switch (activeItem) {
            case 0:
                libraryBody = (
                    <LibraryUpload
                        session={this.state.session}
                        loadCurrentSession={this.showCurrentSession}
                        notify={this.props.notify}
                    />);
                break;
            case 1:
                libraryBody = (
                    <LibraryFiles
                        searchResultsLoading={this.state.searchResultsLoading}
                        showFileDetail={this.showFileDetail}
                        usersData={this.state.usersData}
                        handleLoadMoreData={this.handleLoadMoreData}
                        partialData={this.state.lastKey}
                        tagMultipleFiles={this.tagMultipleFiles}
                        deleteMultipleFiles={this.deleteMultipleFiles}
                        isList={this.state.isList}
                        isPicker={this.props.isPicker}
                        pickerPreFilters={this.props.pickerPreFilters}
                        onPickFiles={this.props.onPickFiles}
                        uploadedIds={this.state.uploadedIds}
                        uploadedFilters={this.state.uploadedFilters}
                        currentSessionLoaded={this.currentSessionLoaded}
                        sessionId={this.state.sessionId}
                        loadSession={this.loadSession}
                        notify={this.props.notify}
                        openContent={this.props.openContent}
                        openFileViewer={this.props.openFileViewer}
                    />
                );
                break;
            default:
                libraryBody = (
                    <div />
                );
        };

        return (
            <div style={{ margin: '15px' }} data-id="library-container">
                <Tabs data-id="library-tabs" value={this.state.activeItem} onChange={this.handleTabChange} classes={{ indicator: this.props.classes.selectedTab }}>
                    {!this.props.isPicker ? <Tab label={LocalizedStrings.upload} data-id="library-tab-upload" /> : ''}
                    <Tab label={LocalizedStrings.files} data-id="library-tab-files" />
                </Tabs>
                <div style={{ paddingTop: '15px' }}>
                    {libraryBody}
                </div>
            </div>
        );
        // }
    }
};
LibraryFrame.propTypes = {
    isPicker: PropTypes.bool.isRequired,
    pickerPreFilters: PropTypes.object,
    onPickFiles: PropTypes.func,
    classes: PropTypes.object.isRequired,
    notify: PropTypes.func,
    openContent: PropTypes.func,
    openFileViewer: PropTypes.func,
};

export default withStyles(styles)(LibraryFrame);